// 在http.js中引入axios
import axios from 'axios'
import QS from 'qs'//引入qs模块，用来序列化post类型的数据
import router from '@/router'
import i18n from '@/Language';
import { Message } from 'element-ui';

const pendingRequests = new Map();

const generateRequestKey = (config) => {
    // 处理请求数据，确保请求和响应时一致,response返回的config中可能存在序列化的data，需要转换成json格式，否则生成的key不一致
    const normalizeData = (data) => {
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch {
          return data;
        }
      }
      return data;
    };
    
    return [
      config.method,
      config.url,
      JSON.stringify(normalizeData(config.params) || {}),
      JSON.stringify(normalizeData(config.data) || {})
    ].join('|');
  };

// => 环境的切换
// if (process.env.NODE_ENV == 'development') {    //开发环境
//   axios.defaults.baseURL = ''; 
// } 

axios.defaults.baseURL = '/';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
// 如果需要跨域，可以设置withCredentials为true
axios.defaults.withCredentials = true; // 允许跨域请求时发送cookies


// 创建axios实例
const service = axios.create({
    baseURL: '/api', // api的base_url
    timeout: 10000,// 请求超时时间
    headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/x-www-form-urlencoded',
        'userRole': 'WEB',
        'Accept-Language': i18n.locale || localStorage.getItem('Accept-Language'),
        'BrowserTimeZone': new Date().getTimezoneOffset() / 60,
    }
});

// 请求拦截器
service.interceptors.request.use(config => {
    config.headers['nh-token'] = localStorage.getItem('NH_TOKEN') || ""
    const token = localStorage.getItem('newToken') || ""
    if (token) config.headers['Authorization'] = 'Bearer ' + token // 新服务添加token
    
    // 生成请求key，用于取消重复的相同请求
    const requestKey = generateRequestKey(config, 'service.interceptors.request');
    // 如果存在相同请求，取消前一个
    if (pendingRequests.has(requestKey)) {
        const abortController = pendingRequests.get(requestKey);
        abortController.abort();
    }
    
    // 为当前请求创建新的控制器
    const controller = new AbortController();
    config.signal = controller.signal;
    pendingRequests.set(requestKey, controller);
    
    return config;
},
    error => {
        return Promise.error(error);
    })
// 响应拦截器
service.interceptors.response.use(
    response => {
        const requestKey = generateRequestKey(response.config, 'service.interceptors.response');
        pendingRequests.delete(requestKey);
        // console.log('Response=>', response.request.responseURL, response  );
        if (response.status === 200) {
            //result  0-正常  1-异常  10000-未登录 4000-系统异常
            if (response.data.result == 10000 || [401].includes(response.data.code)) {
                // 登录失败，跳转到首页，重新登录
                router.push({ path: '/login' })
                return Promise.resolve(response.data)
            } else {
                // 项目迁移后获取登录token
                // if (response.config.url == "/nahui-ems/auth/agent/verify/login" && response.data.code == 200) {
                //     let token = response.headers["nh-token"]
                //     localStorage.setItem('NH_TOKEN', token);
                // }
                return Promise.resolve(response.config.fullResponse ? response : response.data)
            }
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        // 新增：处理请求超时错误
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
            // 使用国际化提示
            const timeoutMessage = i18n.t ? i18n.t('common.requestTimeout') : 'Request timeout. Please check your network or try again later.';
            Message.error({
                message: timeoutMessage,
                duration: 3000
            });
            return Promise.reject(new Error(timeoutMessage));
        }

        if (error.name === 'AbortError') {
            console.log('请求已被取消:', error.message);
            return Promise.reject(new Error('Request cancelled'));
        }
        // 取消请求时，不执行这里的代码
        const requestKey = generateRequestKey(error.config || {});
        pendingRequests.delete(requestKey);
        if (error.status) {
            return Promise.reject(error.response);
        }
    })
export default service

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        service.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params, qr) {
    return new Promise((resolve, reject) => {
        service.post(url, qr ? QS.stringify(params) : params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

// 上传文件函数
export function uploadFile(url, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file); // 'file' 是后端接收文件的字段名
    return service.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress
    });
}
